import { createAsyncThunk } from "@reduxjs/toolkit"

import { stopMessageProcessing } from "@/common/services/chat"

interface StopPlaygroundMessageArgs {
  chatId: string
  authToken: string | null
}

interface StopPlaygroundMessageResult {
  chatId: string
  count: number
  workflowsStopped: number
}

/**
 * Thunk to stop message processing for a Playground chat
 * Calls backend to cancel in-progress AI responses and workflows
 */
export const stopPlaygroundMessage = createAsyncThunk<
  StopPlaygroundMessageResult,
  StopPlaygroundMessageArgs
>("playgroundChat/stopMessage", async ({ chatId, authToken }) => {
  const result = await stopMessageProcessing({
    chatId,
    authToken
  })

  return {
    chatId,
    count: result.count,
    workflowsStopped: result.workflowsStopped
  }
})
